module.exports = __webpack_public_path__ + "img/二维码.01d41816.png";